import * as types from './actionTypes';

// Fetch
export const fetchPayrollStopPaymentRequest = (unit_id) => ({
  type: types.FETCH_PAYROLL_STOP_PAYMENT_REQUEST,
  payload:{unit_id}
});

export const fetchPayrollStopPaymentSuccess = (data) => ({
  type: types.FETCH_PAYROLL_STOP_PAYMENT_SUCCESS,
  payload: data,
});

export const fetchPayrollStopPaymentFailure = (error) => ({
  type: types.FETCH_PAYROLL_STOP_PAYMENT_FAILURE,
  payload: error,
});

// Save
export const savePayrollStopPaymentRequest = (payload) => ({
  type: types.SAVE_PAYROLL_STOP_PAYMENT_REQUEST,
  payload,
});

export const savePayrollStopPaymentSuccess = (response) => ({
  type: types.SAVE_PAYROLL_STOP_PAYMENT_SUCCESS,
  payload: response,
});

export const savePayrollStopPaymentFailure = (error) => ({
  type: types.SAVE_PAYROLL_STOP_PAYMENT_FAILURE,
  payload: error,
});

export const saveReopenpayment = (formData) => ({
  type: types.SAVE_REOPEN_PAYMENT,
  payload: formData,
})